import { supabase } from "../../../../../integrations/supabase/client";
import { useToast } from "../../../../../hooks/use-toast";
import { useState, useEffect } from "react";

export const useDashboardRefresh = (onProfileUpdate: any) => {
  const { toast } = useToast();
  const [scraping, setScraping] = useState(false);
  const [progress, setProgress] = useState<number>(0);
  const [currentPlatform, setCurrentPlatform] = useState<string>("");


  useEffect(() => {
    // Subscribe to scraping progress updates
    const channel = supabase
      .channel("scraping_progress")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "scraping_progress",
        },
        (payload) => {
          const data = payload.new as any;
          if (data.status === "in_progress") {
            const progressPercent = data.total_platforms > 0
              ? Math.round((data.completed_platforms / data.total_platforms) * 100)
              : 0;
            setProgress(progressPercent);
            setCurrentPlatform(data.current_platform || "");
          } else if (data.status === "completed") {
            setProgress(100);
            setScraping(false);
            setTimeout(() => {
              setProgress(0);
              setCurrentPlatform("");
            }, 2000);
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  const handleRefresh = async () => {
    setScraping(true);
    setProgress(0);
    try {
      // Create abort controller with 5 minute timeout (large review sets can take 3-4 minutes per outlet)
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 300000);

      const { error } = await supabase.functions.invoke("scrape-all-platforms", {
        signal: controller.signal,
      });

      clearTimeout(timeoutId);
      if (error) throw error;
      toast({ title: "Success", description: "Reviews are being scraped!" });
      setTimeout(onProfileUpdate, 2000);
    } catch (error: any) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
      setScraping(false);
      setProgress(0);
    }
  };


  return {
    handleRefresh,
    scraping,
    progress,
    currentPlatform
  };
};
